export default `float de( vec3 p){
    float e = 0.05;          
    vec3 b = vec3(.3,.5,.4); 
    p = abs(p)-b;
    vec3 q = abs(p+e)-e;

    return min(min(
      length(max(vec3(p.x,q.y,q.z),0.0))+min(max(p.x,max(q.y,q.z)),0.0),
      length(max(vec3(q.x,p.y,q.z),0.0))+min(max(q.x,max(p.y,q.z)),0.0)),
      length(max(vec3(q.x,q.y,p.z),0.0))+min(max(q.x,max(q.y,p.z)),0.0));
  }`